import { css, Theme } from "@emotion/react";
import { BG_MAIN } from "assets/Common";
import { theme } from "styles/theme";

const typo = theme.typography;
const palette = theme.palette;

export const UserLayoutStyle = {
  self: css`
    background: url(${BG_MAIN}) no-repeat;
    background-size: cover;
    background-position: center;
    min-height: 100%;
    background-color: ${theme.colors.black100};
  `,

  contentWrapper: css`
    display: flex;
    justify-content: center;
    gap: 28px;
    padding: 90px 32px 24px;
    min-width: 1200px;
    min-height: calc(100dvh - 75px - 247px);
    border-radius: 24px;
    margin: 0 16px;
  `,

  mainContent: ({ colors }: Theme) => css`
    flex: 1;
    background: #0a080b80;
    border-radius: 16px;
    padding: 24px;
    border: 1px solid ${theme.borders.primary};

    /* ============================================================
       Typography cascade — consistent across all /user/* pages.
       Pages can opt-out by setting their own font-size on elements.
       ============================================================ */
    font-size: ${typo.body.fontSize};
    font-weight: ${typo.body.fontWeight};
    line-height: ${typo.body.lineHeight};
    color: ${palette.text.primary};
    max-width: 1200px;

    h1,
    .page-title {
      font-size: ${typo.pageTitle.fontSize};
      font-weight: ${typo.pageTitle.fontWeight};
      line-height: ${typo.pageTitle.lineHeight};
      letter-spacing: ${typo.pageTitle.letterSpacing};
      color: ${palette.text.primary};
      margin: 0;
    }

    h2,
    .section-title {
      font-size: ${typo.sectionTitle.fontSize};
      font-weight: ${typo.sectionTitle.fontWeight};
      line-height: ${typo.sectionTitle.lineHeight};
      letter-spacing: ${typo.sectionTitle.letterSpacing};
      color: ${palette.text.primary};
      margin: 0;
    }

    h3,
    .card-title {
      font-size: ${typo.cardTitle.fontSize};
      font-weight: ${typo.cardTitle.fontWeight};
      line-height: ${typo.cardTitle.lineHeight};
      color: ${palette.text.primary};
      margin: 0;
    }

    h4 {
      font-size: ${typo.bodyLg.fontSize};
      font-weight: 600;
      line-height: ${typo.bodyLg.lineHeight};
      color: ${palette.text.primary};
      margin: 0;
    }

    .label,
    label {
      font-size: ${typo.label.fontSize};
      font-weight: ${typo.label.fontWeight};
      line-height: ${typo.label.lineHeight};
      letter-spacing: ${typo.label.letterSpacing};
      color: ${palette.text.secondary};
    }

    .caption,
    small {
      font-size: ${typo.caption.fontSize};
      font-weight: ${typo.caption.fontWeight};
      line-height: ${typo.caption.lineHeight};
      color: ${palette.text.muted};
    }

    .text-primary {
      color: ${palette.text.primary};
    }
    .text-secondary {
      color: ${palette.text.secondary};
    }
    .text-muted {
      color: ${palette.text.muted};
    }
    .text-accent {
      color: ${palette.text.accent};
    }
    .text-success {
      color: ${palette.text.success};
    }
    .text-danger {
      color: ${palette.text.danger};
    }
    .text-info {
      color: ${palette.text.info};
    }

    /* Consistent table cell typography */
    table,
    .table-cell {
      font-size: ${typo.tableCell.fontSize};
      line-height: ${typo.tableCell.lineHeight};
    }
    .table-header {
      font-size: ${typo.tableHeader.fontSize};
      font-weight: ${typo.tableHeader.fontWeight};
      letter-spacing: ${typo.tableHeader.letterSpacing};
    }
  `,
};
